import { Outlet } from 'react-router-dom'
import { useState } from 'react'
import { Menu, X, Home, FileText, Bell, User, LogOut } from 'lucide-react'
import { useClientAuth } from '../contexts/ClientAuthContext'

const ClientLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { client, logout } = useClientAuth()

  const navItems = [
    { name: 'Dashboard', path: '/client/dashboard', icon: Home },
    { name: 'My Cases', path: '/client/cases', icon: FileText },
    { name: 'Documents', path: '/client/documents', icon: FileText },
    { name: 'Notifications', path: '/client/notifications', icon: Bell },
    { name: 'Profile', path: '/client/profile', icon: User },
  ]

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-50 w-64 transform bg-white border-r border-gray-200 transition-transform duration-300 lg:relative lg:translate-x-0 ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex h-16 items-center justify-between px-4 border-b border-gray-200">
          <div className="flex items-center">
            <div className="h-8 w-8 rounded-lg bg-blue-600 flex items-center justify-center">
              <span className="text-lg font-bold text-white">C</span>
            </div>
            <span className="ml-3 text-lg font-semibold text-gray-900">Client Portal</span>
          </div>
          <button
            className="lg:hidden"
            onClick={() => setSidebarOpen(false)}
          >
            <X className="h-6 w-6 text-gray-500" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto py-4">
          <div className="px-4 mb-6">
            <div className="text-sm font-medium text-gray-500">Welcome</div>
            <div className="text-lg font-semibold text-gray-900">{client?.first_name} {client?.last_name}</div>
            <div className="text-sm text-gray-500">{client?.email}</div>
          </div>
          <nav className="space-y-1 px-2">
            {navItems.map((item) => {
              const Icon = item.icon
              return (
                <a
                  key={item.name}
                  href={item.path}
                  className="flex items-center px-3 py-2.5 text-sm font-medium rounded-lg text-gray-700 hover:bg-gray-100"
                >
                  <Icon className="h-5 w-5 mr-3 text-gray-400" />
                  {item.name}
                </a>
              )
            })}
            <button
              onClick={logout}
              className="w-full flex items-center px-3 py-2.5 text-sm font-medium rounded-lg text-red-600 hover:bg-red-50 mt-4"
            >
              <LogOut className="h-5 w-5 mr-3" />
              Logout
            </button>
          </nav>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col lg:pl-0">
        <header className="sticky top-0 z-30 flex h-16 items-center justify-between border-b border-gray-200 bg-white px-4 lg:px-6">
          <button
            className="lg:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu className="h-6 w-6 text-gray-500" />
          </button>
          <div className="flex-1 flex justify-end">
            <div className="flex items-center space-x-4">
              <button className="relative p-1 text-gray-500 hover:text-gray-700">
                <Bell className="h-5 w-5" />
                <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-red-500"></span>
              </button>
              <div className="hidden md:flex items-center">
                <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center">
                  <span className="text-sm font-medium text-blue-600">{client?.first_name?.[0]}</span>
                </div>
                <div className="ml-3">
                  <div className="text-sm font-medium text-gray-900">{client?.first_name} {client?.last_name}</div>
                  <div className="text-xs text-gray-500">Client</div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <main className="flex-1 p-4 md:p-6 overflow-auto">
          <Outlet />
        </main>
      </div>

      {/* Mobile menu button (floating) */}
      <button
        className="fixed bottom-6 right-6 z-40 lg:hidden h-12 w-12 rounded-full bg-blue-600 text-white shadow-lg flex items-center justify-center"
        onClick={() => setSidebarOpen(true)}
      >
        <Menu className="h-6 w-6" />
      </button>
    </div>
  )
}

export default ClientLayout